import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import Activity from './views/Activity.vue';
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{ path: '/', component: Activity }
	]
});

createApp(App).use(router).mount('#app');

